import VectorImg from "images/VectorHIW.svg";
import { FC } from "react";
import NcImage from "shared/NcImage/NcImage";

import img3 from "../../images/_celebration.png";
import img1 from "../../images/_space.png";
import img2 from "../../images/animation-calendar.gif";

export interface SectionHowItWorkProps {
  className?: string;
  data?: {
    id: number;
    title: string;
    desc: string;
    img: string;
    imgDark?: string;
  }[];
}

const DEMO_DATA: SectionHowItWorkProps["data"] = [
  {
    id: 1,
    img: img1,
    title: "Trouver votre espace",
    desc: "Parcourez notre sélection variée d’espaces événementiels : lofts, villas, salles de réception, jardins,… Filtrez par type d’événement, capacité et localisation pour trouver l’espace qui vous correspond.",
  },
  {
    id: 2,
    img: img2,
    title: "Réserver",
    desc: "Accédez aux fiches détaillées des lieux, avec photos, descriptions, tarifs et disponibilités. Réservez en toute sérénité et contactez directement les hôtes pour obtenir davantage d’informations..",
  },
  {
    id: 3,
    img: img3,
    title: "Célébrer",
    desc: "Le jour J, profitez pleinement de votre événement. Que ce soit pour un mariage, une conférence ou une soirée privée, nous vous aidons à réaliser votre projet.",
  },
];

const SectionHowItWork: FC<SectionHowItWorkProps> = ({ className = "", data = DEMO_DATA }) => {
  return (
    <div className={`nc-SectionHowItWork  ${className}`} data-nc-id="SectionHowItWork">
      {/* <Heading isCenter className="md:text-sm">Comment fonctionne notre plateforme de location de salles en Île-de-France ? </Heading> */}
      <h1 className="flex justify-center font-bold md:text-2xl">
        Comment fonctionne notre plateforme de location d’espaces événementiels ?
      </h1>
      <div className="relative grid gap-20 mt-20 md:grid-cols-3 md:gap-x-12">
        <img className="absolute inset-x-0 hidden top-10 md:block" src={VectorImg} alt="" />
        {data.map((item) => (
          <div key={item.id} className="relative flex flex-col items-center max-w-xs mx-auto text-center">
            <div className="mb-4">
              <NcImage containerClassName="mb-4 max-w-[200px] mx-auto" src={item.img} />
            </div>
            <div>
              <h3 className="text-xl font-semibold">{item.title}</h3>
              <span className="block mt-2 text-neutral-500 dark:text-neutral-400">{item.desc}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionHowItWork;
